import { generateQueryParams } from 'utils'
import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class ProductService extends CommonService {
  async createProduct(params: _object) {
    return await this.post('/products', params)
  }

  async getProducts(params: _object) {
    return await this.get(`/products?${generateQueryParams(params)}`)
  }

  async getProductDetails(id: string | undefined) {
    return await this.get(`/products/${id}`)
  }

  async updateProduct(id: string | undefined, params: _object) {
    return await this.put(`/products/${id}`, params)
  }

  async getCountries() {
    return await this.get(`/countries/?per_page=9999`)
  }
  async exportProducts() {
    return await this.get('/products-export')
  }

  async bulkProductsUpdate(params: _object) {
    return await this.post('/products-import', params)
  }

  async mediaUpload(params: _object) {
    return await this.post('/products-images-upload', params)
  }
}

export const productService = new ProductService()
